import React, { useContext, useCallback } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import { CommunityListCardMembers } from "../common";
import CommunityDetail from "./CommunityDetail";

// assets
import icon_more_gray from "bodycodi/cmap/app/svg/icon_more_gray.svg";
import icon_back from "bodycodi/cmap/app/svg/icon_back.svg";

// types
import { CommunityDetailProps } from "./types";

const CommunityDetailPop = ({ details }: CommunityDetailProps) => {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);

  const handleClose = useCallback(() => {
    dispatch({ type: "POP_UP_OPEN", id: "COMUNITY_DTL_POP", open: { comunityDtlPop: false } });
  }, []);

  const handleClickMore = (e: any) => {
    e.stopPropagation();
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_CONFIRM_POP",
      open: { comunityConfirmPop: true },
    });
  };

  return (
    <CustomDialog open={state.comunityDtlPop} onClose={handleClose}>
      <header className="popup-header">
        <div className="community-detail">
          <div onClick={handleClose} className="left-icon">
            <img src={icon_back} />
          </div>
          <div className="comunity-content-header no-margin">
            <CommunityListCardMembers details={details} />
          </div>
        </div>
        {details.postType === "COACH_UPLOAD" && (
          <div className="right-icon" onClick={handleClickMore}>
            <img src={icon_more_gray} />
          </div>
        )}
      </header>
      <CommunityDetail details={details} />
    </CustomDialog>
  );
};

export default CommunityDetailPop;
